import React, { FC, useState } from 'react';
import { styled } from 'linaria/react';
import { useBreakpoint } from '@mtsbank/ui-kit';
import { takeNewYearGiveawayParticipationClickGtm } from '@shared/lib/gtm';
import { PaymentButton } from '@shared/ui/atoms';
import PromoEndModal from './PromoEndModal';
interface TakeParticipationButtonProps {
  withSnow?: boolean;
  variant?: 'red' | 'green';
}
const TakeParticipationButton: FC<TakeParticipationButtonProps> = ({
  withSnow = false,
  variant = 'red'
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const {
    isMobile
  } = useBreakpoint();
  const handleModalOpen = () => {
    setIsModalOpen(true);
    takeNewYearGiveawayParticipationClickGtm();
    // window.recordTier?.push({ eventName: 'landingpageClick', tracking_id: '128633737' })
    // window._tmr?.push({ type: 'reachGoal', id: 3712315, goal: 'start_registration' })
  };
  const handleModalClose = () => setIsModalOpen(false);
  return <>
      <TakeParticipationButtonWrapper>
        <PaymentButton type="button" height={isMobile ? 60 : 72} title="Принять участие" bannerButtonBgColor={variant === 'red' ? 'linear-gradient(180deg, #ED3A43 0%, #B32931 100%)' : 'linear-gradient(180deg, #30C372 0%, #0D6426 100%)'} bannerButtonBottomColor={variant === 'red' ? '#981E25' : '#074715'} bannerButtonStartIcon="https://staticpayment.ssl.mts.ru/upload/snowflake.svg" onClick={handleModalOpen} />
      </TakeParticipationButtonWrapper>
      {/* <PromoNotStartedYetModal open={isModalOpen} onClose={handleModalClose} /> */}
      {/* <TakeParticipationModal open={isModalOpen} onClose={handleModalClose} /> */}
      <PromoEndModal open={isModalOpen} onClose={handleModalClose} />
    </>;
};
export default TakeParticipationButton;
const TakeParticipationButtonWrapper = /*#__PURE__*/styled('div')({
  name: "TakeParticipationButtonWrapper",
  class: "tsrnex4",
  propsAsIs: false
});
const SnowWrapper = /*#__PURE__*/styled('div')({
  name: "SnowWrapper",
  class: "s1f0q2l1",
  propsAsIs: false
});

require("./TakeParticipationButton.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TakeParticipationButton.tsx");